import { BulkButton } from '@bo-components/common/BulkButton';
import type { ConfirmationModalProps } from '@library/components/modals/ConfirmationModal';
import { DNPSelect } from '@bo-components/scoring/Selects/DNPSelect';
import { DateTime } from 'luxon';
import type { GamePlayerProjectionsAndScoresRequest } from '@library/types/projection';
import { formatWithTimezoneChange } from '@library/utils/dateTime';
import { useUpdateBulkProjectionsMutation } from '@bo-services/projectionsApi';

interface BulkDNPButtonProps {
  setConfirmationModalProps: (
    props: Omit<ConfirmationModalProps, 'onCancelModal'> | false
  ) => void;
  scoringQueryParams: GamePlayerProjectionsAndScoresRequest;
}

export const BulkDNPButton = ({
  setConfirmationModalProps,
  scoringQueryParams
}: BulkDNPButtonProps) => {
  const {
    leagueId,
    fromDate,
    toDate,
    search,
    gameId,
    team,
    statTypeIds,
    status,
    durationId
  } = scoringQueryParams;

  const [bulkUpdateProjections, { isLoading, isError }] =
    useUpdateBulkProjectionsMutation();

  const handleConfirm = async (isEnabled: boolean) => {
    const scorePayload: Record<string, boolean> = {
      is_off_the_board: isEnabled
    };

    // Only set is_final to true when enabling DNP
    if (isEnabled) {
      scorePayload.is_final = true;
    }

    await bulkUpdateProjections({
      league_ids: leagueId ?? [],
      from_date: formatWithTimezoneChange(
        DateTime.fromISO(fromDate || ''),
        'LL/dd/yyyy'
      ),
      to_date: toDate
        ? formatWithTimezoneChange(DateTime.fromISO(toDate), 'LL/dd/yyyy')
        : undefined,
      search: search ?? '',
      game_ids: gameId ? [gameId] : undefined,
      teams: team ? [team] : undefined,
      stat_type_ids: statTypeIds ?? undefined,
      statuses: status,
      duration_ids: durationId,
      ignore_update_limit: false,
      projection: {},
      score: scorePayload
    });
  };

  return (
    <BulkButton
      setConfirmationModalProps={setConfirmationModalProps}
      label="Bulk DNP"
      confirmationLabel="Bulk Changing DNP"
      buttonText="Bulk DNP"
      SelectComponent={DNPSelect}
      enabledText="Enable"
      disabledText="Disable"
      isLoading={isLoading}
      isError={isError}
      handleConfirm={handleConfirm}
    />
  );
};
